import { isConsumer } from 'owa-session-store';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export const isSuggestedUnsubscribeEnabled = () => {
    return isConsumer() && isMiniHostAppFeatureEnabled('suggestedUnsubscribe');
};
